import axiosClient from "./client";

export const getTags = () => {
    return axiosClient.get(`/app/tags`).then((response) => response);
};
